/**
 * @desc 提交
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: defs.basics.CertMainRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/certMain/submit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
